import React, { useEffect } from 'react'
import SearchPage from '../../../../customComponents/SearchPage'
import { useDispatch, useSelector } from 'react-redux'
import { searchProducts } from '../../../Desktop/Pages/ProductListing/Categories/Apis/productListingSlice'
import { fetchCartDetails } from '../../../../utils/cartSlice'
import { useNavigate } from 'react-router-dom'

const MobileNavbarInside = ({ user }) => {
	const { productQuantity } = useSelector((state) => state.cart)
	const dispatch = useDispatch()
	const navigate = useNavigate()

	useEffect(() => {
		if (user) {
			dispatch(fetchCartDetails())
		}
		const body = { search: '' }
		dispatch(searchProducts(body))
	}, [])
	const productsSearchChange = (e) => {
		const body = {
			search: e.target.value,
		}
		dispatch(searchProducts(body))
	}
	return (
		<div className='display-full display-mob '>
			<div className='d-flex justify-content-center background-image-yellow align-items-center mob-bg-smoke shadow gap-2 fixed-top z-index-3 p-1'>
				<div>
					<a onClick={() => navigate(-1)}>
						<img src='../../assets/img/svg/back.svg' className='opacity-10 me-1' width='24' height='24' alt='' />{' '}
					</a>
				</div>
				<div className='w-75'>
					<div className='input-group input-group-outline align-items-center'>
						<input
							type='text'
							className='form-control bg-white'
							placeholder='Search for Products, Brands and More'
							// data-bs-toggle='offcanvas'
							// data-bs-target='#offcanvasRightSearch'
							// aria-controls='offcanvasRight'
							onChange={productsSearchChange}
						/>
						<span className='input-group-text end-3 opacity-5 position-absolute'>
							<img src='../../assets/img/svg/search.svg' height='20' alt='' />
						</span>
					</div>
				</div>
				<div>
					<a href='/Cart'>
						<div class='icon icon-md-2  bg-white border shadow text-center rounded-circle p-1 position-relative'>
							<i class='bi bi-handbag-fill fs-5 text-primary opacity-9'>
								<span
									className='mt-1 position-absolute translate-middle badge-sm small text-dark'
									style={{ fontStyle: 'normal', top: '4px', left: '32px' }}
								>
									{productQuantity ?? 0}
								</span>
							</i>
						</div>
					</a>
				</div>
			</div>
			<div class='offcanvas offcanvas-end w-100' tabindex='-1' id='offcanvasRightSearch' aria-labelledby='offcanvasRightLabel'>
				<div class=' container-fluid p-1 shadow'>
					<div className=' align-items-center'>
						<div class='input-group input-group-outline align-items-center'>
							<a href=''>
								<i
									class='bi bi-arrow-left-short me-2 fa-2x icon-color'
									aria-hidden='true'
									data-bs-dismiss='offcanvas'
									aria-label='Close'
								></i>
							</a>
							<input type='text' class='form-control' placeholder='Search for Products, Brands and More' />
							<span class='input-group-text end-3 opacity-5 position-absolute'>
								<img src='../../assets/img/svg/search.svg' height='20' alt='' />
							</span>
						</div>
					</div>
				</div>
				<div class='offcanvas-body'>
					<SearchPage />
				</div>
			</div>
		</div>
	)
}

export default MobileNavbarInside
